import analyticsCache from './analyticsCache';
import { clearRegisteredCaches } from './cacheRegistry';

/**
 * Wipe every client-side data cache that belongs to the person logging out
 * (policy C16): the analytics localStorage entries, the services' in-memory and
 * sessionStorage list caches (`erp_*_cache_*`) and the in-window form seed
 * caches. The next login — possibly a different user with a different warehouse
 * scope — then starts from the server, not from the previous user's lists.
 */
export function clearSessionCaches() {
  try { analyticsCache.clearAll(); } catch (e) { /* ignore */ }
  // Module-level Map caches survive a logout (no page reload) — clear them too.
  try { clearRegisteredCaches(); } catch (e) { /* ignore */ }

  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith('erp_') && k.includes('_cache')) sessionStorage.removeItem(k);
    }
  } catch (e) { /* ignore */ }

  try {
    delete window.ordersFormCache;
    delete window.purchaseOrdersFormCache;
    delete window.inquiryFormCache;
  } catch (e) { /* ignore */ }
}

export default clearSessionCaches;
